export default __webpack_public_path__ + "static/media/Snowmelt.756482b8.webp";